import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { ReactComponent as RequalifyIcon } from '../../../../../assets/icons/refresh.svg';
import EventAuthor from '../eventAuthor';
import EventDate from '../eventDate';
import useStyles from '../styles';

const Requalified = ({ translations, record }) => {
  const classes = useStyles();

  return (
    <div className={classes.authorEvent}>
      <div className={classes.eventHeader}>
        <div className={classes.eventInfo}>
          <div className={classes.icon}>
            <RequalifyIcon
              className={classNames(classes.eventIcon, classes.requalifyIcon)}
            />
          </div>
          <EventAuthor translations={translations} record={record} />
        </div>
        <EventDate record={record} />
      </div>
      <Typography
        className={classes.eventDetails}
        variant="body1"
        component="div"
      >
        {`${translations.requalifiedOnStep} `}
        <Typography variant="subtitle1" component="span">
          {record.step_title}
        </Typography>
      </Typography>
    </div>
  );
};

Requalified.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  record: PropTypes.object.isRequired,
};

export default Requalified;
